import { useApiQuery } from '@/hooks/useApiQuery';
import { settingsKeys } from '@/lib/queryKeys';
import type { BillingInfo } from '@/types/settings';

// `/api/settings/billing` was a monolith endpoint that returned the
// tenant's plan + usage meters. Operations has no equivalent yet, so
// the /dashboard/settings/subscription page 404'd on mount.
//
// The page already says "Plan management can be wired once the tenant
// subscription backend exists" — return null so it renders the empty
// no-plan state cleanly instead of logging a 404. No HTTP call.
export function useBilling() {
  return useApiQuery<BillingInfo | null>({
    queryKey: settingsKeys.billing(),
    queryFn: () => Promise.resolve(null),
    showErrorToast: false,
    staleTime: Infinity,
  });
}
